// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"370":"75336afb","649":"75336afb"}[chunkId] + ".chunk.css");